import type { MultiBrandConfig } from './types';

// Website 04 — AquaGlass Global Connect storefront. Working brand: AquaGlobe.
// Premium, guided, "smooth as water" glassmorphism positioning. Frosted glass
// surfaces, teal→lavender gradients, data-usage calculator + network coverage
// language (aqua-day / aqua-night palettes). Name/domain are PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now because every storefront shares
// ONE backend (functions/ + billing worker + D1). Before AquaGlobe is deployed
// as its own indexed property it MUST get its own canonical domain + contact
// email to avoid cross-brand duplicate-content / canonical conflicts (risk R14).
// Until then it is build-selectable for preview only (BRAND_ID=aquaglass-global-connect).
export const aquaglobe: MultiBrandConfig = {
  id: 'aquaglass-global-connect',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'Premium, guided glassmorphism storefront for travelers who want a calm, smooth, "everything-handled" experience — clear data sizing, live network confidence, and frictionless setup over the cheapest price.',
  theme: {
    mode: 'light', // frosted white / lavender, light-first
    defaultDark: 'aqua-night',
    defaultLight: 'aqua-day',
  },
  checkoutEnabled: true,
  // App-centric global connectivity brand: lead with global/regional plans. Presentation only.
  pricingDisplayMode: 'app-global-first',
  legacy: {
    brand: {
      name: 'AquaGlobe',
      displayName: 'AquaGlobe',
      tagline: 'Travel Connected. Seamlessly.',
      description:
        'Premium global travel eSIMs with a calm, guided setup. Size your data, check live network coverage, and connect the moment you land in 180+ countries — no plastic, no roaming fees.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'AquaGlobe Logo',
    },
    contact: {
      // Shared support inbox for now (shared backend). Swap to a brand inbox at launch.
      // TODO(brand-email): planned dedicated inbox `hello@esimsleek.com` (TBD) before indexed launch (R14).
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      // PROVISIONAL — see domain note above. Own domain required before launch.
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} AquaGlobe. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Reliable 4G/5G',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimsleek.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'AQUAGLO',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimsleek.com',
      url: 'https://esimsleek.com',
      organizationLegalName: 'TBD — register legal entity for AquaGlobe',
    },
    llms: {
      tagline: 'Premium global connectivity, beautifully simple',
      audience: 'Premium travelers who want a calm, guided, everything-handled eSIM experience.',
    },
  },
};

export default aquaglobe;
